import { Component, OnInit } from '@angular/core';
import { WebNavbarComponent } from '../../web-components/web-navbar/web-navbar.component';
import { WebFooterComponent } from '../../web-components/web-footer/web-footer.component';

@Component({
    standalone: true,
    selector: 'app-shipping-and-delivery',
    templateUrl: './shipping-and-delivery.component.html',
    styleUrls: ['./shipping-and-delivery.component.css'],
    imports: [WebNavbarComponent, WebFooterComponent]
})
export class ShippingAndDeliveryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
